import AppDataService from "./AppDataService";

const COMMON_BASE = 'Report'

export default class ReportDataService {
	static async getHeadersForPayerReport() {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersForPayerReport`);
	}
	static async getHeadersForRecipientReport() {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersForRecipientReport`);
	}
	static async getHeadersFormsDeliveryReport() {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersFormsDeliveryReport`);
	}
	static async getHeadersForTinReport() {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersForTinReport`);
	}
	static async getHeadersForW9Report(data) {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersForW9Report`);
	}
	static async getHeadersForW8Report(data) {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersForW8Report`);
	}
	static async getHeadersForOPTReport(data) {
		return await AppDataService.get(`${COMMON_BASE}/GetHeadersOptInReport`);
	}
	static async downloadPayerReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadPayerReport`, data);
	}
	static async downloadOptInReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadOptInReport`, data);
	}
	static async getSubmissionHistoryReport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetSubmissionHistoryReport`, { params });
	}
	static async getDataUnsubmittedFormsReport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetDataUnsubmittedFormsReport`, { params });
	}
	static async getDataUnsubmittedFormsReportExport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetDataUnsubmittedFormsReportExport`, { params });
	}
	static async getStateSubmissionHistoryReport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetStateSubmissionHistoryReport`, { params });
	}
	static async downloadPayerByUserReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadPayerReportByUser`, data);
	}
	static async downloadRecipientReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadRecipientReport`, data);
	}
	static async downloadW9Report(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadW9Report`, data);
	}
	static async downloadW8Report(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadW8Report`, data);
	}
	static async downloadFormsDeliveryReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadFormsDeliveryReport`, data);
	}
	static async downloadTinReport(data) {
		return await AppDataService.post(`${COMMON_BASE}/DownloadTinReport`, data);
	}
	static async getInvoiceReport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetInvoiceReport`, { params });
	}
	static async getQBOVendorHistoryReportGridData(params) {
		return await AppDataService.get(`${COMMON_BASE}/getQBOVendorHistoryReportGridData`, { params });
	}
	static async getQBOVendorHistoryReportGridExport() {
		return await AppDataService.get(`${COMMON_BASE}/getQBOVendorHistoryReportGridExport`);
	}
	static async get1099VendorCopyeDeliveryGrid(params) {
		return await AppDataService.get(`${COMMON_BASE}/Get1099VendorCopyeDeliveryGrid`, { params });
	}
	static async getW9EmailStatusGrid(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetW9EmailStatusGrid`, { params });
	}
	static async getOptInEmailStatusGrid(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetGetOptInEmailStatusGrid`, { params });
	}
	static async getOptInStatusReporExport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetOptInStatusReporExport`, { params });
	}
	static async get1099VendorCopyeDeliveryGridExport(params) {
		return await AppDataService.get(`${COMMON_BASE}/Get1099VendorCopyeDeliveryGridExport`, { params });
	}
	static async getW9CopyStatusReportExport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetW9CopyStatusReportExport`, { params });
	}
	static async updateEmailId(data) {
		return await AppDataService.post(`${COMMON_BASE}/UpdateEmailId`, data);
	}
	static async getUSPSAmount(data) {
		return await AppDataService.post(`${COMMON_BASE}/GetUSPSAmount`, data);
	}
	static async USPSMailTORecipient(data) {
		return await AppDataService.post(`${COMMON_BASE}/USPSMailTORecipient`, data);
	}
	static async getPaymentsReceiptsReport(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetPaymentsReceipts`, { params });
	}
	static async getStatePayrollStateNames() {
		return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollStates`);
	}
	static async getStatePayrollFormNames(params) {
		return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollFormNames?stateName=${params}`)
	}
	static async getDownloadStatePayrollHistory(formLabel, fromDate, toDate) {
		return await AppDataService.get(`${COMMON_BASE}/DownloadStatePayrollHistory?FormName=${formLabel}&fromDate=${fromDate}&toDate=${toDate}`);
	}
}